import React from 'react';
import {AppBar, Box, Grid, IconButton, Toolbar, Typography} from "@mui/material";
import shadzi from "../../assets/images/Group 2224.png";
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

const Header = () => {
    return (
        <div>
            <Box sx={{flexGrow: 1}}>
                <AppBar position="static">
                    <Toolbar sx={{background: "#592EA9"}}>
                        <Grid sx={{flexGrow:1}}>
                        <img src={shadzi} alt={'logo'} style={{width: '80px', height: 'auto'}}/>
                        </Grid>
                        <IconButton
                            size="large"
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            sx={{mr: 'auto'}}
                        >
                                <PeopleAltOutlinedIcon />
                        </IconButton>
                </Toolbar>
            </AppBar>
        </Box>
</div>
)
    ;
};

export default Header;